import React from "react";
import { HeaderConfig, appliedConfig } from "../config/commonConfig";
import WhatsAppButton from "./WhatsAppButton";

function Pricing() {
  return (
    <section
      id="pricing"
      className={
        "section bg-light " +
        (appliedConfig.appliedHeader === HeaderConfig.SideHeaderDark ||
        appliedConfig.appliedHeader === HeaderConfig.SideHeaderLight
          ? "px-lg-4 "
          : " ")
      }
    >
      <div className="container">
        <h2 className="text-9 fw-600 text-center">Cursos Especializados em Trânsito</h2>
        <hr className="heading-separator-line bg-primary opacity-10 mx-auto" />
        <p className="lead text-center mb-5">
          De Norte a Sul, motoristas confiam e buscam nossos cursos online.
        </p>
        <div className="row gy-4">
          <div className="col-sm-6 col-lg-4">
            <div className="card text-center border-0 shadow-md">
              <div className="card-header d-flex align-items-center justify-content-center text-6 fw-500 text-bg-secondary border-bottom-0 py-4">
                Transporte Coletivo de Passageiros
              </div>
              <div className="card-body">
                <p className=" text-4 badge text-bg-warning fw-600 rounded-pill">
                  Formação:
                </p>
                <ul className="list-style-2 text-2 text-start">
                  <li>
                    <span className="text-1 me-2">
                      <i className="fas fa-check" />
                    </span>
                    Capacita motoristas para conduzir ônibus e micro-ônibus com segurança, focando em legislação, direção defensiva e atendimento ao passageiro.
                  </li>
                </ul>
                <p className=" text-4 badge text-bg-warning fw-600 rounded-pill">
                  Atualização:
                </p>
                <ul className="list-style-2 text-2 text-start">
                  <li>
                    <span className="text-1 me-2">
                      <i className="fas fa-check" />
                    </span>
                    Reciclagem obrigatória a cada 5 anos para motoristas, reforçando legislação, segurança e práticas atualizadas no trânsito.
                  </li>
                </ul>
                <WhatsAppButton text="ENTRE EM CONTATO" />
              </div>
            </div>
          </div>
          <div className="col-sm-6 col-lg-4">
            <div className="card text-center border-0 shadow-md">
              <div className="card-header d-flex align-items-center justify-content-center text-6 fw-500 text-bg-secondary border-bottom-0 py-4">
                <p>
                  Transporte Escolar
                </p>
              </div>
              <div className="card-body">
                <p className=" text-4 badge text-bg-warning fw-600 rounded-pill">
                  Formação:
                </p>
                <ul className="list-style-2 text-2 text-start">
                  <li>
                    <span className="text-1 me-2">
                      <i className="fas fa-check" />
                    </span>
                    Prepara profissionais para conduzir veículos de transporte de estudantes, abordando responsabilidade, normas legais e cuidados com crianças e adolescentes.
                  </li>
                </ul>
                <p className=" text-4 badge text-bg-warning fw-600 rounded-pill">
                  Atualização:
                </p>
                <ul className="list-style-2 text-2 text-start">
                  <li>
                    <span className="text-1 me-2">
                      <i className="fas fa-check" />
                    </span>
                    Reciclagem obrigatória a cada 5 anos para motoristas, reforçando legislação, segurança e práticas atualizadas no trânsito.
                  </li>
                </ul>
                <WhatsAppButton text="ENTRE EM CONTATO" />
              </div>
            </div>
          </div>
          <div className="col-sm-6 col-lg-4">
            <div className="card text-center border-0 shadow-md">
              <div className="card-header d-flex align-items-center justify-content-center text-6 fw-500 text-bg-secondary border-bottom-0 py-4">
                Transporte de Produtos Perigosos (MOPP)
              </div>
              <div className="card-body">
                <p className=" text-4 badge text-bg-warning fw-600 rounded-pill">
                  Formação:
                </p>
                <ul className="list-style-2 text-2 text-start">
                  <li>
                    <span className="text-1 me-2">
                      <i className="fas fa-check" />
                    </span>
                    Treinamento para motoristas que transportam cargas perigosas, com foco em segurança, prevenção de acidentes e legislação específica.
                  </li>
                </ul>
                <p className=" text-4 badge text-bg-warning fw-600 rounded-pill">
                  Atualização:
                </p>
                <ul className="list-style-2 text-2 text-start">
                  <li>
                    <span className="text-1 me-2">
                      <i className="fas fa-check" />
                    </span>
                    Reciclagem obrigatória a cada 5 anos para motoristas, reforçando legislação, segurança e práticas atualizadas no trânsito.
                  </li>
                </ul>
                <WhatsAppButton text="ENTRE EM CONTATO" />
              </div>
            </div>
          </div>
        </div>
        <div className="row gy-4 mt-2">
          <div className="col-sm-6 col-lg-4">
            <div className="card text-center border-0 shadow-md">
              <div className="card-header d-flex align-items-center justify-content-center text-6 fw-500 text-bg-secondary border-bottom-0 py-4">
                Transporte de Cargas Indivisíveis
              </div>
              <div className="card-body">
                <p className=" text-4 badge text-bg-warning fw-600 rounded-pill">
                  Formação:
                </p>
                <ul className="list-style-2 text-2 text-start">
                  <li>
                    <span className="text-1 me-2">
                      <i className="fas fa-check" />
                    </span>
                    Forma condutores para o transporte de cargas superdimensionadas, abordando técnicas de condução, escolta e normas de tráfego.
                  </li>
                </ul>
                <p className=" text-4 badge text-bg-warning fw-600 rounded-pill">
                  Atualização:
                </p>
                <ul className="list-style-2 text-2 text-start">
                  <li>
                    <span className="text-1 me-2">
                      <i className="fas fa-check" />
                    </span>
                    Reciclagem obrigatória a cada 5 anos para motoristas, reforçando legislação, segurança e práticas atualizadas no trânsito.
                  </li>
                </ul>
                <WhatsAppButton text="ENTRE EM CONTATO" />
              </div>
            </div>
          </div>
          <div className="col-sm-6 col-lg-4">
            <div className="card text-center border-0 shadow-md">
              <div className="card-header d-flex align-items-center justify-content-center text-6 fw-500 text-bg-secondary border-bottom-0 py-4">
                Transporte de Emergência
              </div>
              <div className="card-body">
                <p className=" text-4 badge text-bg-warning fw-600 rounded-pill">
                  Formação:
                </p>
                <ul className="list-style-2 text-2 text-start">
                  <li>
                    <span className="text-1 me-2">
                      <i className="fas fa-check" />
                    </span>
                    Habilita motoristas para conduzir ambulâncias, com foco em direção defensiva, primeiros socorros e condução em situações críticas.
                  </li>
                </ul>
                <p className=" text-4 badge text-bg-warning fw-600 rounded-pill">
                  Atualização:
                </p>
                <ul className="list-style-2 text-2 text-start">
                  <li>
                    <span className="text-1 me-2">
                      <i className="fas fa-check" />
                    </span>
                    Reciclagem obrigatória a cada 5 anos para motoristas, reforçando legislação, segurança e práticas atualizadas no trânsito.
                  </li>
                </ul>
                <WhatsAppButton text="ENTRE EM CONTATO" />
              </div>
            </div>
          </div>
          <div className="col-sm-6 col-lg-4">
            <div className="card text-center border-0 shadow-md">
              <div className="card-header d-flex align-items-center justify-content-center text-6 fw-500 text-bg-secondary border-bottom-0 py-4">
                Reciclagem de CNH
              </div>
              <div className="card-body">
                <ul className="list-style-2 text-2 text-start">
                  <li>
                    <span className="text-1 me-2">
                      <i className="fas fa-check" />
                    </span>
                    Curso destinado a condutores que tiveram a suspensão do direito de dirigir, abordando legislação, direção defensiva e cidadania no trânsito.
                  </li>
                </ul>
                <WhatsAppButton text="ENTRE EM CONTATO" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Pricing;
